<template>
    <input
      v-on:input="validateCode($event)"
      placeholder="Zip/Postal Code"
      size="10"
      class="input1"
      type="text"
      :maxlength="this.country == 'US' ? 5 : 7">
</template>

<script>
import $ from 'jquery'

const pcRegex = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/
const zipRegex = /^\d{5}(-\d{4})?$/
export default {
  data() {
    return {
        postalCode: '',
    };
  },
  props: {
    onError: {
      type: Function,
      defalt: () => {}
    },
    country: {
      type: String
    }
  },
  methods: {
    validateCode(e){
      console.log(this.country)
        const value = e.target.value
        this.postalCode = value
        if (this.country == 'CA') {
          if(pcRegex.test(this.postalCode)) {
            this.$emit("input", this.postalCode)
            this.$emit("onError", this.onError(false))
          } else {
            this.$emit("onError", this.onError(true))
          }
        } else if(this.country == 'US') {
          if(zipRegex.test(this.postalCode)) {
            this.$emit("input", this.postalCode)
            this.$emit("onError", this.onError(false))
          } else {
            this.$emit("onError", this.onError(true))
          }
        } else {
          this.$emit("input", this.postalCode)
        }
        this.$emit('changesMade')
    }
  }
};
</script>

<style scoped>

</style>
